import { render, staticRenderFns } from "./CenterData.vue?vue&type=template&id=0a0bf8d3"
import script from "./CenterData.vue?vue&type=script&lang=js"
export * from "./CenterData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports